
import WebService from "../../WebService"

const Filter = {
    gets(params) {
        return WebService.get("/console/contest/filter/list?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/filter/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/filter", data)
    },
    update(data) {
        return WebService.post("/console/contest/filter/" + data.filter_id, data)
    },
}
export default Filter